import React, { useEffect, useState } from 'react'
import { Calendar } from 'primereact/calendar'
import './../form.scss'
import { PropsType } from '../../../models/util'
import { addLocale } from 'primereact/api'

export interface DatePickerProps extends PropsType {
    onChangeCallback: (e: any) => void // on change callback
    value: Date // input value(s), could be string, string[], Date, {start: Date, end: Date}

    // to override primereact and/or wardrobe styles, use custom classes
    classes?: string // css classes for the element
    containerClasses?: string // css classes for the <div> container
    style?: any

    mandatory?: boolean // adds * in labels (TODO validation message)
    disabled?: boolean // if true the element is disabled
    colWidth?: number | string // set element width from 1 to 12 columns (default: 12)

    label?: string // label
    floatingLabel?: boolean // floating labels appear only when the field is filled in
    placeholder?: string // placeholder

    maxDate?: Date // maximum date (for start and end date)
    minDate?: Date // minimum date (for start and end date)
    firstDayOfWeek?: number // first day of the week in month table

    additionalProps?: any // pass props for the Prime React original component

    // the calendar icon is not customizable
}

const DatePicker = (props: DatePickerProps) => {
    const {
        onChangeCallback,
        value,
        colWidth,
        disabled,
        additionalProps,
        containerClasses,
        style,
        minDate,
        maxDate,
        floatingLabel,
        mandatory,
        label,
        firstDayOfWeek,
    } = props

    let today = new Date()
    let year = today.getFullYear()

    const [viewDate, setViewDate] = useState<any>(today)

    useEffect(() => {
        if (minDate) {
            setViewDate(new Date(minDate))
        } else if (maxDate) {
            setViewDate(new Date(maxDate))
        } else {
            setViewDate(today)
        }
    }, [minDate, maxDate])

    // set first day of the week
    addLocale('custom', {
        firstDayOfWeek: firstDayOfWeek ? firstDayOfWeek : 0,
    })

    return (
        <div
            className={`wardrobe-form-input p-col-${
                colWidth ? colWidth : '12'
            } ${containerClasses ? containerClasses : ''} ${
                label ? 'labeled-input' : ''
            }`}>
            <Calendar
                panelClassName="wardrobe-datepicker"
                locale="custom"
                monthNavigator
                yearNavigator
                yearRange={`1970:${year + 5}`}
                baseZIndex={2000}
                showButtonBar
                // inputStyle={style ? style : {}}
                showIcon
                icon="cu cu-calendar"
                className="w-100 wardrobe-calendar"
                disabled={disabled}
                value={value}
                dateFormat="yy/mm/dd"
                selectionMode="single"
                style={style}
                placeholder={
                    props.placeholder ? props.placeholder : 'Select a Date'
                }
                appendTo={document.body}
                onChange={(e) => onChangeCallback(e.value)}
                {...additionalProps}
                minDate={minDate}
                maxDate={maxDate}
                viewDate={viewDate}
                onViewDateChange={(e) => {
                    setViewDate(e?.value)
                }}
            />
            {label && (
                <label className={`${floatingLabel && !value ? 'empty' : ''}`}>
                    {`${label}${mandatory ? ' *' : ''}`}
                </label>
            )}
        </div>
    )
}

export default DatePicker
